import { MastheadLink, MastheadLinkList } from 'lib/sanity/types';
import { isMastheadLinkList } from 'utils/type-guards';

export const isLinkVisible = (item: MastheadLink | MastheadLinkList, isUserLoggedIn: boolean) => {
  if (isMastheadLinkList(item) || item.displayOptions === undefined) {
    return true;
  }

  const option = isUserLoggedIn ? 'hideForLoggedIn' : 'hideForLoggedOut';

  return !item.displayOptions.includes(option);
};

export const isLinkDisabled = (item: MastheadLink, isUserLoggedIn: boolean) => {
  if (item.displayOptions === undefined) {
    return false;
  }

  const option = isUserLoggedIn ? 'disabledForLoggedIn' : 'disabledForLoggedOut';

  return item.displayOptions.includes(option);
};
